module.exports = __webpack_public_path__ + "components/country-flag/static/nf-0f85d1475e88f5013572db63b6389ca9.svg";